import * as redux from 'redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';

import mySaga from '../sagas/sagas';

import authReducer from '../reducers/authReducer';
import formReducer from '../reducers/formReducer';
import basicInfoReducer from '../reducers/basicInfoReducer';
import educationInfoReducer from '../reducers/educationInfoReducer';
import professionalInfoReducer from '../reducers/professionalInfoReducer';
import otherInfoReducer from '../reducers/otherInfoReducer';
import ptRequirementsInfoReducer from '../reducers/ptRequirementsInfoReducer';
import appInfoReducer from '../reducers/appInfoReducer';
import applicationReducer from '../reducers/applicationReducer';

export const configure = (initialState = {}, context = {}) => {
  const sagaMiddleware = createSagaMiddleware();

  const reducer = redux.combineReducers({
    auth: authReducer,
    form: formReducer,
    basicInfo: basicInfoReducer,
    educationInfo: educationInfoReducer,
    professionalInfo: professionalInfoReducer,
    otherInfo: otherInfoReducer,
    ptRequirementsInfo: ptRequirementsInfoReducer,
    appInfo: appInfoReducer,
    application: applicationReducer
  });

  const store = redux.createStore(
    reducer,
    initialState,
    redux.compose(
      redux.applyMiddleware(thunk),
      redux.applyMiddleware(sagaMiddleware),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
  );

  sagaMiddleware.run(mySaga, context);

  return store;
};